import {
	IconButtonCompat as IconButton,
	IStackItemStyles,
	LabelCompat as Label,
	SeparatorCompat as Separator,
	StackCompat as Stack,
	TooltipHostCompat as TooltipHost,
} from 'components/FluentUICompat';
import {ControlledTextField, EnumDropdown} from 'components/hookForms';
import React from 'react';
import {
	Control,
	useFieldArray,
	UseFieldArrayAppend,
	UseFieldArrayRemove,
} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {LabelWithTooltip} from 'features/localizedTooltips';
import {AppendButton} from 'components/hookForms/AppendButton';
import {Keyword, Market, TranslationLang} from 'types';

const fieldName = 'translations';

export const TranslationFieldKeyword: React.FC<{control: Control<Keyword>}> = ({
	control,
}) => {
	const {fields, remove, append} = useFieldArray<Keyword>({
		control,
		name: fieldName,
	});

	return (
		<TranslationFieldBasic
			fields={fields}
			remove={remove}
			append={append}
			control={control}
		/>
	);
};

export const TranslationFieldMarket: React.FC<{control: Control<Market>}> = ({
	control,
}) => {
	const {fields, remove, append} = useFieldArray<Market>({
		control,
		name: fieldName,
	});

	return (
		<TranslationFieldBasic
			fields={fields}
			remove={remove}
			append={append}
			control={control}
		/>
	);
};

const TranslationFieldBasic: React.FC<{
	fields: Record<'id', string>[];
	remove: UseFieldArrayRemove;
	append: UseFieldArrayAppend<any, string>;
	control: any;
}> = ({fields, remove, append, control}) => {
	const {t} = useTranslation('components/translationfield');

	return (
		<React.Fragment>
			<Label>{t('Translation')}</Label>
			<Stack tokens={{childrenGap: 8}}>
				{fields.map((field, index) => (
					<Stack key={index} horizontal tokens={{childrenGap: 8}}>
						<Stack.Item grow styles={stackItemStyles}>
							{index === 0 && (
								<LabelWithTooltip translationKey={'lang'}>
									{t('Lang')}
								</LabelWithTooltip>
							)}
							<EnumDropdown
								control={control}
								name={`${fieldName}[${index}].${'lang'}`}
								enumName={'TranslationLang'}
								enumType={TranslationLang}
								defaultValue={TranslationLang.De}
								tooltipHostProps={{shouldGetTextFromContext: false}}
							/>
						</Stack.Item>
						<Stack.Item grow styles={stackItemStyles}>
							{index === 0 && (
								<LabelWithTooltip translationKey={'translation'}>
									{t('Translation')}
								</LabelWithTooltip>
							)}
							<ControlledTextField
								control={control}
								name={`${fieldName}[${index}].${'translation'}`}
								rules={{
									required: t('Required'),
								}}
								tooltipHostProps={{shouldGetTextFromContext: false}}
							/>
						</Stack.Item>
						<Stack.Item>
							<TooltipHost content={t('ToolTipDelete')}>
								<IconButton
									styles={{
										root: {marginTop: index === 0 ? 28 : 0},
									}}
									iconProps={{iconName: 'Delete'}}
									onClick={() => remove(index)}
								/>
							</TooltipHost>
						</Stack.Item>
					</Stack>
				))}
			</Stack>
			<AppendButton
				onClick={() => {
					append({});
				}}
				label={t('Translation')}
				name={fieldName}
			/>
		</React.Fragment>
	);
};

const stackItemStyles: IStackItemStyles = {
	root: {
		width: 100,
	},
};
